import script from "./FlexEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./FlexEditor.vue?vue&type=script&setup=true&lang=js"

import "./FlexEditor.vue?vue&type=style&index=0&id=9137675a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9137675a"]])

export default __exports__